// utils/modalScrollLock.ts
const scrollPosition = { top: 0, left: 0 };

function preventScroll(e: Event) {
  e.preventDefault();
}

function preventKeyScroll(e: KeyboardEvent) {
  const keys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Space'];
  if (keys.includes(e.key)) e.preventDefault();
}

export function lockPageScroll() {
  scrollPosition.top = window.scrollY || document.documentElement.scrollTop;
  scrollPosition.left = window.scrollX || document.documentElement.scrollLeft;

  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition.top}px`;
  document.body.style.left = `-${scrollPosition.left}px`;
  document.body.style.width = '100%';

  window.addEventListener('wheel', preventScroll, { passive: false });
  window.addEventListener('keydown', preventKeyScroll, { passive: false });
}

export function unlockPageScroll() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.width = '';

  window.scrollTo(scrollPosition.left, scrollPosition.top);

  window.removeEventListener('wheel', preventScroll);
  window.removeEventListener('keydown', preventKeyScroll);
}
